// NPM
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { useTranslation } from 'react-i18next';
import { isEmpty, map } from 'lodash';

// ANT COMPONENT
import { Col, Row, Space } from 'antd';
import { CloseOutlined } from '@ant-design/icons'
import { FilterOutlined } from '@ant-design/icons';
import { SkeletonLoader } from "@life-line-lab/components-react";

// STYLE
import './product-catalog.scss';

// HELPER
import { decode, encode } from 'Helpers/enc';

// HOOK
import useSession from 'Hooks/session.hook';
import useQuery from "Hooks/query.hook";

// COMPONENT
import ProductListingNew from "Components/product/product-listing-new";
import classNames from "classnames";

interface ProductCategoryProps {
  products: Array<any>;
  categories: Array<any>;
  isLoading: boolean;
  isLevel1Only?: boolean;
  onCategorySelect?: (data: any) => void;
  onMainCategorySelect?: () => void;
  onClearCategorySelect?: () => void;
}

const ProductCatalog: React.FC<ProductCategoryProps> = ({
  products,
  categories,
  isLoading,
  isLevel1Only,
  onCategorySelect,
  onMainCategorySelect,
  onClearCategorySelect,
}) => {
  const history = useHistory();
  const { t } = useTranslation();
  const { profile } = useSession();
  const query = useQuery();
  const name: any = query.get('name');
  const subName: any = query.get('subName');
  const category: any = query.get('category');
  const category2: any = query.get('category2');
  const categoryID = decode(category);
  const category2ID = decode(category2);
  let categoryFilters: any = []
  categoryID && categoryFilters.push(categoryID)
  category2ID && categoryFilters.push(category2ID)

  return (
    <div className="product-catalog">
      <Space direction="vertical" size="middle">

        <Row gutter={16}>
          <Col lg={4} md={4} sm={0} xs={0}>
            <div className="filter">
              <h4 className="title"><img src="/assets/images/category-main.svg" width={20} /> {t('label.categories')}</h4>

              <div className="category">
                {isLevel1Only && name &&
                  <h4 className="clear"
                    onClick={() => { if (onClearCategorySelect) onClearCategorySelect() }}
                  >
                    <CloseOutlined /> {t('action.clearFilter')}
                  </h4>
                }

                {!isLevel1Only &&
                  <h4 className={
                    classNames({
                      'color-secondary': categoryFilters.includes(categoryID),
                      'color-primary': !categoryFilters.includes(categoryID)
                    })}
                    onClick={() => { if (onMainCategorySelect) onMainCategorySelect() }}
                  >
                    {decode(name)}
                  </h4>
                }

                {map(categories, (category) => {
                  return (
                    <h4
                      key={category._id}
                      className={classNames({
                        'ml-10': !isLevel1Only,
                        'color-secondary': categoryFilters.includes(category._id),
                        'color-primary': !categoryFilters.includes(category._id)
                      })} onClick={() => { if (onCategorySelect) onCategorySelect(category) }}
                    >
                      {category.name}
                    </h4>
                  )
                })}
              </div>
            </div>
          </Col>

          {isLoading ?
            <>
              <SkeletonLoader type="default" />
              <SkeletonLoader type="default" />
              <SkeletonLoader type="default" />
            </>
            :
            <Col lg={20} md={20} sm={24} xs={24}>

              {name &&
                <h3 className="color-primary mb-10">
                  {/*{t('label.showingResultsFor')}&nbsp;&nbsp;*/}
                  <span className="color-secondary">
                    {`${decode(name)}${subName ? ' > ' + decode(subName) : ''}`}
                  </span>
                </h3>
              }

              {!isEmpty(products) ?
                <React.Fragment>
                  <div className="product-listing-new">
                    <Row gutter={24}>
                      {map(products, (o, index) => {
                        const price = parseFloat(o.stockVariants[0]?.value);
                        const stockLimit = o.stockVariants[0]?.stockLimit ? parseInt(o.stockVariants[0]?.stockLimit) : 0;
                        const percentOff = 10;
                        const discountPrice = price + (price * 10 * 0.01);
                        const discounted = o.discountPrice
                          ? (parseFloat(o.price) - parseFloat(o.discountPrice)).toFixed(2) : 0;
                        return (
                          <Col lg={6} md={6} sm={12} xs={12}>
                            <ProductListingNew
                              product={{
                                displayType: 'saved',
                                imageUrl: o.featuredImage?.image,
                                productImages: o.productImages,
                                name: o.product.productName,
                                productType: o.product.productType,
                                price: discountPrice.toFixed(2),
                                stockLimit: stockLimit,
                                discountPrice: price.toFixed(2),
                                percentOff: percentOff,
                                productData: o,
                                supplierLocation: o.orgData?.primaryAddress?.city || null,
                                disablePurchase: o.disablePurchase,
                                href: `/products/${encode(o.inventoryID)}`,
                                discounted: discounted
                              }}
                            />
                          </Col>
                        )
                      })}
                    </Row>
                  </div>
                </React.Fragment>
                :
                <div className="text-center">
                  <img src={process.env.ACCOUNT_TYPE == 'P2U' ? "/assets/images/product/no-result-p2u.png" : "/assets/images/product/no-result-drezy.png"} width="150" />
                  <div><h3>{t('label.NoResultsFound')}</h3></div>
                </div>
              }
            </Col>

          }
        </Row>
      </Space>
    </div>
  )
}

export default ProductCatalog;
